import { graphql } from "../gql";

export const setClaimDisputedMutationDoc = graphql(`
  mutation setClaimDisputed($input: SetClaimDisputedInput!) {
    setClaimDisputed(input: $input) {
      id
      disputed
    }
  }
`);
